var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.Charge"),
        width: "1200px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c("tab-charges", {
            ref: "tabCharge",
            staticStyle: {
              height: "600px",
              padding: "0",
              "min-width": "1180px"
            },
            attrs: {
              context: _vm.chargeDialog.context,
              action: _vm.chargeDialog.action,
              "is-bpm": true
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }